const ACCESS_LEVELS = Object.freeze({
  EDITABLE: "editable",
  READ_ONLY: "read-only",
  UNAUTHORIZED: "unauthorized",
});
// constants/user-type.constants.js

const ROLE_ACCESS_TYPE = Object.freeze({
  FULL: "full",
  EDIT: "edit",
  READ: "read",
  READ_ONLY: "read-only",
  UNAUTHORIZED: "Unauthorized",
});

const sections = {
  INTERNAL_USER: {
    name: "Internal User",
  },
  PRESCRIBER: { name: "Prescriber" },
};

const ROLES = Object.freeze({
  sections,
  permissions: {
    CUSTOMER_SUPPORT: {
      name: "Customer Support",
      sections: sections.INTERNAL_USER.name,
      permissions: {}, // You can define specific access rights here later
    },
  },
});

export default {
  ROLES,
  ACCESS_LEVELS,
  ROLE_ACCESS_TYPE,
};
